import { StyledDataWrapper } from '../../../molecules/UserPanel/StyledDataWrapper';
import { StyledText } from "../../../atoms/Text/StyledText";
import { getString } from '../../../../strings';

const PlayersInfo = ({ players, event }) => {
    const confirmed = players?.confirmed?.length || 0;
    const unconfirmed = players?.unconfirmed?.length || 0;
    const reserve = players?.reserve?.length || 0;
    const total = confirmed + unconfirmed;
    const confirmedNewcomers = (players?.confirmed || []).filter((p) => !p.wca_id).length;
    const otherNewcomers = [
        ...(players?.unconfirmed || []),
        ...(players?.rejected || []),
    ].filter((p) => !p.wca_id).length;

    return (
        <>
            <StyledDataWrapper>
                <StyledText
                    hasdeclaredfontsize="20px"
                    hasdeclaredfontweight="600"
                    hasdeclaredfontcolor="#4E6BAA"
                    hasdeclaredpadding="0 8px 0 0"
                >
                    ZAWODNICY:
                </StyledText>

                <StyledText
                    hasdeclaredfontsize="20px"
                    hasdeclaredfontweight="600"
                    hasdeclaredfontcolor="#000"
                >
                    {confirmed > 0 && (
                        <span style={{ color: '#5FEE5C' }}>
                            {confirmed}
                        </span>
                    )}

                    {unconfirmed > 0 && (
                        <>
                            {'|'}
                            <span>{total}</span>
                            {'|'}
                            <span style={{ color: '#DF7B63' }}>
                                {unconfirmed}
                            </span>
                        </>
                    )}

                    {event?.max_places && (
                        <>
                            {' / '}
                            <span style={{ color: '#6786be' }}>
                                {event.max_places}
                            </span>
                        </>
                    )}

                    {reserve > 0 && (
                        <>
                            {' ('}
                            <span>{reserve}</span>
                            {')'}
                        </>
                    )}
                </StyledText>
            </StyledDataWrapper>
            <StyledDataWrapper>
                <StyledText
                    hasdeclaredfontsize="20px"
                    hasdeclaredfontweight="600"
                    hasdeclaredfontcolor="#4E6BAA"
                    hasdeclaredpadding="0 8px 0 0"
                >
                    {getString('userPanel_playersInfo_newcomers')}:
                </StyledText>
                <StyledText
                    hasdeclaredfontsize="20px"
                    hasdeclaredfontweight="600"
                    hasdeclaredfontcolor="#000"
                >
                    <span style={{ color: '#F74017' }}>{confirmedNewcomers}</span>
                    {otherNewcomers > 0 && (
                        <span>{` (${otherNewcomers})`}</span>
                    )}
                </StyledText>
            </StyledDataWrapper>
        </>
    );
};

export default PlayersInfo;
